<template>
  <div class="middle cadfm-flexitem-stretched">

    <action-panel>
      <action-bar>
        <b-navbar-nav>

          <action-button
            v-if="isPlugin&&appConf.status.isPL&& !appConf.status.isBasicBundle && currentUser.role != 'Reader'"
            @click="placePart" icon="place" bold :text="lang.button_Place" :tooltip="lang.button_Place"
            :disabled="placeButtonStatus" />
          <action-button v-if="currentUser.role != 'Reader'" @click="_new" icon="new" bold :text="lang.button_New"
            :tooltip="lang.button_New" :disabled="newButtonStatus" />
          <action-button @click="details" icon="details-part" bold :text="lang.button_Details"
            :tooltip="lang.button_Details" :disabled="detailsButtonStatus" />

          <action-button v-if="currentUser.role != 'Reader'" @click="derive" icon="derive" bold
            :text="lang.button_Derive" :tooltip="lang.button_Derive" :disabled="deriveButtonStatus" />

          <action-button v-if="currentUser.role=='Admin' && globalSettings.deletionOfElements" @click="_delete"
            icon="remove" bold :text="lang.button_Delete" :tooltip="lang.button_Delete"
            :disabled="deleteButtonStatus" />
          <action-button v-if="currentUser.role != 'Reader'" @click="removeRevision" icon="remove" bold
            :text="lang.button_RemoveRevision" :tooltip="lang.button_RemoveRevision"
            :disabled="removeRevisionButtonStatus" />
          <action-button v-if="currentUser.role != 'Reader'" @click="withdraw" icon="withdraw" bold
            :text="lang.button_Withdraw" :tooltip="lang.button_Withdraw" :disabled="withdrawButtonStatus" />
          <action-button v-if="currentUser.role=='Admin'" @click="moveTo" icon="move-to" bold :text="lang.button_MoveTo"
            :tooltip="lang.button_MoveTo" :disabled="moveToButtonStatus" />
          <action-button v-if="currentUser.role != 'Reader'" @click="assembly" v-show="!appConf.status.isBasicBundle"
            icon="assembly" bold text="Assembly" tooltip="Assembly" :disabled="assemblyButtonStatus" />
          <!-- <action-button  @click="moveto"  icon="move-to" bold text="Move to" tooltip="Move to" :disabled="movetoButtonStatus"/> -->
          <action-button v-if="currentUser.role != 'Reader'" @click="_import" icon="import" bold
            :text="lang.button_Import" :tooltip="lang.button_Import" :disabled="importButtonStatus" />
          <action-button v-if="(currentUser.role=='Admin')" @click="properties" icon="properties" bold
            :text="lang.button_Properties" :tooltip="lang.button_Properties" :disabled="propertiesButtonStatus" />
          <action-button @click="search" icon="physicals" bold :text="lang.button_SearchOutside"
            :tooltip="lang.button_SearchOutside" :disabled="searchButtonStatus" />
          <action-button v-if="!isPlugin && currentUser.role != 'Reader'" @click="addPhysical" icon="add-physical" bold
            :text="lang.button_AddPhysical" :tooltip="lang.button_AddPhysical" :disabled="addPhysicalButtonStatus" />




        </b-navbar-nav>
        <b-navbar-nav class="ml-auto">
          <action-button v-show="!$parent.isVisibleLeft" @click="toggleLeftPanel" icon="show" bold
            :text="lang.button_Left" :tooltip="lang.button_Left" :disabled="toggleButtonStatus" />
          <action-button v-show="!$parent.isVisibleRight" @click="toggleRightPanel" icon="show" bold
            :text="lang.button_Right" :tooltip="lang.button_Right" :disabled="toggleButtonStatus" />

        </b-navbar-nav>

      </action-bar>

      <action-content id="action_content_parts">
        <Content :lang="lang.Content"></Content>
      </action-content>
    </action-panel>

  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ActionBar from '@/components/shared/ActionBar'
import ActionButton from '@/components/shared/ActionButton'
import ActionContent from '@/components/shared/ActionContent'
import ActionPanel from '@/components/shared/ActionPanel'
import TitleComponent from "@/components/shared/TitleComponent"
import Content from "@/components/PartManager/Views/PartTable/Middle/Content/Content"
import PartPropertiesType from '@/constants/PartPropertiesType'

export default {
  name: 'Middle',
  components: {
    ActionBar,
    ActionButton,
    ActionContent,
    ActionPanel,
    TitleComponent,
    Content
  },
 props:{
    
    lang: Object
  },
  data () {
    return {
      
      detailsButtonStatus: true,
      deriveButtonStatus: true,
      deleteButtonStatus: true,
      removeRevisionButtonStatus: true,
      placeButtonStatus: true,
      newButtonStatus: false,
      assemblyButtonStatus: true,
      withdrawButtonStatus: true,
      toggleButtonStatus: false,
      moveToButtonStatus: true,
      importButtonStatus: false,
      propertiesButtonStatus: false,
      searchButtonStatus: false,
      addPhysicalButtonStatus: true,
      toggleRightPanelIcon: 'view'
    }
  },
  created(){
    
  },
  computed: {
    ...mapGetters({
      currentUser: 'currentUser',
      selectedRows: 'selectedRows',
      isPlugin: 'isPlugin',
      appConf: 'appConf',
      globalSettings: "globalSettings"
    }),

  },
  watch: {
    selectedRows: function (new_isData, old_isData) {
      //for details button
      if (this.selectedRows.length == 1){
        this.detailsButtonStatus = false

      }else{
         this.detailsButtonStatus = true
      }
      //for withdraw button
      if (this.selectedRows.length > 0){
        this.withdrawButtonStatus = false

      }else{
         this.withdrawButtonStatus = true
      }
      //for derive button
      if (this.selectedRows.length == 1){
        this.deriveButtonStatus = false

      }else{
         this.deriveButtonStatus = true
      }
      //for delete button
      if (this.selectedRows.length > 0){
        this.deleteButtonStatus = false

      }else{
         this.deleteButtonStatus = true
      }
      //for removeRevision button
      if (this.selectedRows.length > 0) {
        let trig = false;
        
          for (let i = 0, lei = this.selectedRows.length; i < lei; i++){
            if (this.selectedRows[i].col___status != undefined) {
              if (this.selectedRows[i].col___revisionId.requestorUserId == this.currentUser.userId && this.selectedRows[i].col___status.value.display == "pending") {
                
              } else {
                
                trig = true;
                break;
              }
              
            }
          }
        
        
        if (trig == true) {
          this.removeRevisionButtonStatus = true;
        } else {
          this.removeRevisionButtonStatus = false;
        }
      } else {
        
        this.removeRevisionButtonStatus = true
      }
      //for move button
      if (this.selectedRows.length > 0) {
        this.moveToButtonStatus = false

      } else {
        this.moveToButtonStatus = true
      }
      //for place button
      if (this.selectedRows.length == 1) {

        if (this.globalSettings.placingPrototype) {
          this.placeButtonStatus = false;
        } else {
          if (this.selectedRows[0].col___status.value != undefined) {
            if (this.selectedRows[0].col___status.value.display == "active") {
              this.placeButtonStatus = false;
            } else {
              this.placeButtonStatus = true;
            }
          }
          
        } 
        
        

      }else{
         this.placeButtonStatus = true
      }
      //for place button
      if (this.selectedRows.length == 1){
        this.assemblyButtonStatus = false

      }else{
         this.assemblyButtonStatus = true
      }
      //for add physical
      if (this.selectedRows.length == 1){
        this.addPhysicalButtonStatus = false

      }else{
         this.addPhysicalButtonStatus = true
      }
      if (this.selectedRows[0] != undefined){
        if(this.selectedRows[0].col___status.assembly){
          //this.detailsButtonStatus = true
          //this.withdrawButtonStatus = true
          this.deriveButtonStatus = true
          this.assemblyButtonStatus = true


        }
      }
      


    }
  },
  methods: {
    
    details(){

      let to = "/PartManager/PartDetails";

      this.$store.dispatch("editPropertiesForm", false);

      let routingObject = {
        from: this.$route.path,
        to: to,
        revisionId: this.$store.getters.selectedRows[0].col___revisionId.revisionId,
        id: this.$store.getters.selectedRows[0].col___revisionId.partId,
        sourceType: "main", //"details"
        sourceId: "",
        sourceRevisionId: "",
        end: true
      }

      this.$store.commit("FORWARDROUTINGDATA", routingObject)

      
      // const query = {
      //   from: this.$route.path,
      //   to: to,
      //   revisionId: this.$store.getters.selectedRows[0].col___revisionId.revisionId,
      //   id: this.$store.getters.selectedRows[0].col___revisionId.partId
      // }

      this.$router.push({ path: to, query: routingObject });
    },
    _new(){

      let to = "/PartManager/PartNew";
      

      

      const query = {
        from: this.$route.path,
        to: to,
        
      }

      this.$router.push({ path: to, query: query });
    },
    derive() {

      let to = "/PartManager/PartDerive";
      
      


      
      const query = {
        from: this.$route.path,
        to: to,
        source: "PartTable",
        revisionId: this.$store.getters.selectedRows[0].col___revisionId.revisionId,
        id: this.$store.getters.selectedRows[0].col___revisionId.partId
      }

      this.$router.push({ path: to, query: query });
    },
    _delete(){

      
      let vue = this;

      let deleteProjectFunc = function(){
        vue.$store.dispatch("showLoader", { visible: true, text: "wait" });
        let selectedRows = [];
        for (let i = 0, lei = vue.$store.getters.selectedRows.length; i < lei; i++) {
          selectedRows.push(vue.$store.getters.selectedRows[i].col___revisionId.partId);
        }

        const arr = {
          partIds: selectedRows
        }
        

        vue.$store.dispatch( vue.$store.getters.sectionPrefix + "_bulkDeletePart", arr)
        .then((result) =>{

          console.log(result)
          vue.$store.dispatch("showLoader", { visible: false, text: "" });
          let obj = {};
          if (result.status == "OK"){

            if (result.data != null) {

              let tab = [];
              for (let i = 0, lei = result.data.length; i < lei; i++){

                if (result.data[i].success == false) {
                  tab.push(result.data[i]);
                }

              }
              if (tab.length > 0) {
                const obj = {
                    title: vue.lang.modal_title_BulkFeedback,
                    text: "",
                    type: "bulk_feedback",
                    buttons: 1,
                    buttonName: vue.lang.modal_button_Close,
                    size: "xl",
                    lang: vue.lang.modal_BulkFeedback,
                    funcNo: "",
                    funcYes: "",
                    funcCustom: "",
                    data: { data: tab }
                  };
                  vue.$store.dispatch("showModalComponent", obj);
              } else {
                let successAlert = "";
                if (result.data.length == 1) {
                  successAlert = vue.lang.alert_success_delete_part
                } else {
                  successAlert = vue.lang.alert_success_delete_parts
                }
                obj = {
                    text: successAlert,
                    time: 10,
                    type: "success"
                  }
              }

              
              
              const reloadObj = {
                  status: true,
                  name: "DataTableFilteredOnApiComponent"
              }
              vue.$store.dispatch("reloadAfterActionComplex", reloadObj);

            }else{
              obj = {
                text: vue.lang.alert_error_delete_part + ". ",
                time: 15,
                type: "danger"
              }

            }
          }else{
            obj = {
              text: vue.lang.alert_error_delete_part + ": " + result.message,
              time: 15,
              type: "danger"
            }

          }
          vue.$store.dispatch("displayFooterAlert", obj);
        })
      }   

      const obj = {
        title: vue.lang.modal_title_delete,
        text: this.lang.alert_delete,
        type: "sure",
        buttons: 2,
        size: "sm",
        funcYes: deleteProjectFunc,
        funcNo: ""
      };

      this.$store.dispatch("showAlert", obj);
    },
    removeRevision() {
      
      let vue = this;

      let removeFunc = function () {
        vue.$store.dispatch("showLoader", { visible: true, text: "wait" });
        let selectedRows = [];
        for (let i = 0, lei = vue.$store.getters.selectedRows.length; i < lei; i++) {
          selectedRows.push(vue.$store.getters.selectedRows[i].col___revisionId.revisionId);
        }

        const arr = {
          partRevisionIds: selectedRows
        }

        vue.$store.dispatch(vue.$store.getters.sectionPrefix + "_bulkRemoveRevision", arr)
          .then((result) => {

            console.log(result)
            vue.$store.dispatch("showLoader", { visible: false, text: "" });
            let obj = {};
            if (result.status == "OK") {

              
              if (result.data != null) {

                let tab = [];
                for (let i = 0, lei = result.data.length; i < lei; i++) {

                  if (result.data[i].success == false) {
                    tab.push(result.data[i]);
                  }

                }
                if (tab.length > 0) {
                  const obj = {
                    title: vue.lang.modal_title_BulkFeedback,
                    text: "",
                    type: "bulk_feedback",
                    buttons: 1,
                    buttonName: vue.lang.modal_button_Close,
                    size: "xl",
                    lang: vue.lang.modal_BulkFeedback,
                    funcNo: "",
                    funcYes: "",
                    funcCustom: "",
                    data: { data: tab }
                  };
                  vue.$store.dispatch("showModalComponent", obj);
                } else {
                  obj = {
                    text: vue.lang.alert_success_removeRevision_part,
                    time: 10,
                    type: "success"
                  }
                }

                
                const reloadObj = {
                  status: true,
                  name: "DataTableFilteredOnApiComponent"
                }
                vue.$store.dispatch("reloadAfterActionComplex", reloadObj);

              } else {
                obj = {
                  text: vue.lang.alert_error_removeRevision_part,
                  time: 15,
                  type: "danger"
                }

              }
            } else {
              obj = {
                text: vue.lang.alert_error_removeRevision_part + ": " + result.message,
                time: 15,
                type: "danger"
              }

            }
            vue.$store.dispatch("displayFooterAlert", obj);
          })
      }

      const obj = {
        title: vue.lang.modal_title_removeRevision,
        text: this.lang.alert_removeRevision,
        type: "sure",
        buttons: 2,
        size: "sm",
        funcYes: removeFunc,
        funcNo: ""
      };

      this.$store.dispatch("showAlert", obj);
    },
    withdraw(){

      let _vue = this;
      
      let alert_success_withdraw = this.lang.alert_success_withdraw;
      let alert_error_withdraw = this.lang.alert_error_withdraw;

      let withdrawParts = function(){
        const arr = [];
        _vue.$store.dispatch("showLoader", { visible: false, text: "" });
                
        for (var i = 0, le = _vue.$store.getters.selectedRows.length; i < le; i++){
          arr.push(_vue.$store.getters.selectedRows[i].col___revisionId.partId)

        }
        
        const obj = {
          partIds: arr
        }
        
        _vue.$store.dispatch(_vue.$store.getters.sectionPrefix+"_bulkSetWithdraw", obj)
        .then((result) => {
          
          console.log(result)
          _vue.$store.dispatch("showLoader", { visible: false, text: "" });

          if (result.status == "OK"){

            if (result.data != null) {

              let tab = [];
              for (let i = 0, lei = result.data.length; i < lei; i++) {

                if (result.data[i].success == false) {
                  tab.push(result.data[i]);
                }

              }
              if (tab.length > 0) {
                const obj = {
                  title: _vue.lang.modal_title_BulkFeedback,
                  text: "",
                  type: "bulk_feedback",
                  buttons: 1,
                  buttonName: _vue.lang.modal_button_Close,
                  size: "xl",
                  lang: _vue.lang.modal_BulkFeedback,
                  funcNo: "",
                  funcYes: "",
                  funcCustom: "",
                  data: { data: tab }
                };
                _vue.$store.dispatch("showModalComponent", obj);
              } else {
                let obj = {
                  text: alert_success_withdraw,
                  time: 5,
                  type: "success"
                }

                _vue.$store.dispatch("displayFooterAlert", obj);
              }


              const reloadObj = {
                  status: true,
                  name: "DataTableFilteredOnApiComponent"
              }
              _vue.$store.dispatch("reloadAfterActionComplex", reloadObj);

            }else{
              let obj = {
                text: alert_error_withdraw + ": " + result.message,
                time: 10,
                type: "danger"
              }

              _vue.$store.dispatch("displayFooterAlert", obj);
            }
     
          }else{
            let obj = {
              text: alert_error_withdraw + ": " + result.message,
              time: 10,
              type: "danger"
            }

            _vue.$store.dispatch("displayFooterAlert", obj);

          }
        })

      }
            
      const obj = {
        title: "Withdraw",
        text: this.lang.alert_withdraw,
        type: "withdraw",
        buttons: 2,
        size: "sm",
        funcYes: withdrawParts,
        funcNo: "",

      }
 
      this.$store.dispatch("showAlert", obj);


    },

    assembly(){

      let to = "/PartManager/PartAssembly";
      
      
      const query = {
        from: this.$route.path,
        to: to,
        revisionId: this.$store.getters.selectedRows[0].col___revisionId.revisionId,
        id: this.$store.getters.selectedRows[0].col___revisionId.partId
      }

      this.$router.push({ path: to, query: query });

    },
    _import() {

      let to = "/PartManager/PartImport";
      
      

      
      const query = {
        from: this.$route.path,
        to: to,
        
      }

      this.$router.push({ path: to, query: query });
    },
    properties() {

      let to = "/PartManager/Properties";
      
     

      
      const query = {
        from: this.$route.path,
        to: to,

      }

      this.$router.push({ path: to, query: query });
    },
    search() {

      let to = "/PartManager/PartSearch";

      
      
      const query = {
        from: this.$route.path,
        to: to,
        source: "",
        
      }

      

      let routingObject = {
        from: this.$route.path,
        to: to,
        //revisionId: this.$store.getters.selectedRows[0].col___revisionId.revisionId,
        //id: this.$store.getters.selectedRows[0].col___revisionId.partId,
        sourceType: "main", //"details"
        sourceId: "",
        sourceRevisionId: "",
        end: true
      }

      if (this.$store.getters.selectedRows.length > 0) {
        routingObject.revisionId = this.$store.getters.selectedRows[0].col___revisionId.revisionId;
        routingObject.id = this.$store.getters.selectedRows[0].col___revisionId.partId;

      }


      this.$store.commit("FORWARDROUTINGDATA", routingObject)


      this.$router.push({ path: to, query: routingObject });
    },
    addPhysical() {

      let to = "/PartManager/PartPhysicals";

      const query = {
        from: this.$route.path,
        to: to,
        source: "new"
        
      }

      if (this.$store.getters.selectedRows.length > 0) {
        query.revisionId = this.$store.getters.selectedRows[0].col___revisionId.revisionId;
        query.id = this.$store.getters.selectedRows[0].col___revisionId.partId;
      }

      this.$router.push({ path: to, query: query });
    },
    placePart(){
      
      let vue = this;

      let partnumber = {};
      let symbol = {};
      let value = {};
      let footprint = {};
      let otherProps = [];
      for(let el in this.$store.getters.selectedRows[0]){
        
        if (this.$store.getters.selectedRows[0][el].type == PartPropertiesType.PARTNUMBER){
          
          partnumber.name = this.$store.getters.selectedRows[0][el].name;
          partnumber.value = this.$store.getters.selectedRows[0][el].value.display;
          partnumber.visibility = this.$store.getters.selectedRows[0][el].visibility;
        } else if (this.$store.getters.selectedRows[0][el].type == PartPropertiesType.SYMBOL){
          symbol.value = this.$store.getters.selectedRows[0][el].value.display;
          symbol.visibility = this.$store.getters.selectedRows[0][el].visibility;
        } else if (this.$store.getters.selectedRows[0][el].type == PartPropertiesType.VALUE){
          value.name = this.$store.getters.selectedRows[0][el].name;
          value.value = this.$store.getters.selectedRows[0][el].value.display;
          value.visibility = this.$store.getters.selectedRows[0][el].visibility;
        } else if (this.$store.getters.selectedRows[0][el].type == PartPropertiesType.FOOTPRINT){
          footprint.value = this.$store.getters.selectedRows[0][el].value.display;
          footprint.visibility = this.$store.getters.selectedRows[0][el].visibility;

        } else {
          otherProps.push({
            name: this.$store.getters.selectedRows[0][el].name,
            value: this.$store.getters.selectedRows[0][el].value.display,
            visibility: this.$store.getters.selectedRows[0][el].visibility
            });
        }
      }
      

      

      const obj = {
        revisionId: this.$store.getters.selectedRows[0].col___revisionId.revisionId,
        partnumber: partnumber,
        symbol: this.$store.getters.currentSymbol.currentSymbolName,
        packageDevice: this.$store.getters.currentSymbol.currentPackage,
        revision: this.$store.getters.selectedRows[0].col___revision.value.display,
        value: value,
        footprint: footprint,
        otherProps: otherProps
      }

         
          
      if (this.$store.getters.currentSymbol.currentSymbolName == undefined) {
        
        let obj = {
          text: vue.lang.alert_error_EmptySymbolName,
          time: 15,
          type: "danger"
        }

        vue.$store.dispatch("displayFooterAlert", obj);
        return;
      }
       if (this.$store.getters.currentSymbol.isActive != true) {

        let obj = {
          text: vue.lang.alert_error_NoActive,
          time: 15,
          type: "danger"
        }

        vue.$store.dispatch("displayFooterAlert", obj);
        return;
      }
        

      this.$store.dispatch(this.$store.getters.sectionPrefix + "_placePart", obj)
        .then((result) => {
          console.log(result)
        },
        (result) => {
          
          result = JSON.parse(result);
          console.log(result)
          console.warn("error:", result.message);
          
          let obj = {
            text: vue.lang.alert_error_PlacePart + ": " + result.message,
            time: 15,
            type: "danger"
          }

          vue.$store.dispatch("displayFooterAlert", obj);
        }
        )
      
    },
    moveTo() {


      let vue = this;


      let funcYes = function (e) {
        vue.$store.dispatch("showLoader", { visible: true, text: "wait" });
        let newMovingCategory = vue.$store.getters.newMovingCategory;

        let selectedRows = [];
        for (let i = 0, lei = vue.$store.getters.selectedRows.length; i < lei; i++) {
          selectedRows.push(vue.$store.getters.selectedRows[i].col___revisionId.partId);
        }


        let obj = {
          partIds: selectedRows,
          categoryId: newMovingCategory.categoryId
        }

        if (obj.categoryId == undefined) {
          let obj = {
            text: vue.lang.alert_error_MovePartCategory,
            time: 15,
            type: "danger"
          };

          vue.$store.dispatch("displayFooterAlert", obj);
          vue.$store.dispatch("showLoader", { visible: false, text: "" });
          return;
        }
        
        vue.$store.dispatch(vue.$store.getters.sectionPrefix + "_bulkMoveToAnotherCategory", obj)
          .then(function (result) {

            console.log(result)
            vue.$store.dispatch("showLoader", { visible: false, text: "" });
            if (result.status == "OK") {



              if (result.data != null) {

                let tab = [];
                for (let i = 0, lei = result.data.length; i < lei; i++) {

                  if (result.data[i].success == false) {
                    tab.push(result.data[i]);
                  }

                }
                if (tab.length > 0) {
                  const obj = {
                    title: vue.lang.modal_title_BulkFeedback,
                    text: "",
                    type: "bulk_feedback",
                    buttons: 1,
                    buttonName: vue.lang.modal_button_Close,
                    size: "xl",
                    lang: vue.lang.modal_BulkFeedback,
                    funcNo: "",
                    funcYes: "",
                    funcCustom: "",
                    data: { data: tab }
                  };
                  vue.$store.dispatch("showModalComponent", obj);
                } else {
                  let obj = {
                    text: vue.lang.alert_success_MovePart,
                    time: 10,
                    type: "success"
                  };
                  vue.$store.dispatch("displayFooterAlert", obj);
                }

                

                


                //reload table
                const reloadObj = {
                  status: true,
                  name: "DataTableFilteredOnApiComponent"
                }
                vue.$store.dispatch("reloadAfterActionComplex", reloadObj);
              } else {
                let obj = {
                  text: vue.lang.alert_error_MovePart,
                  time: 15,
                  type: "danger"
                };

                vue.$store.dispatch("displayFooterAlert", obj);
              }

            } else {
              let obj = {
                text: vue.lang.alert_error_MovePart,
                time: 15,
                type: "danger"
              };

              vue.$store.dispatch("displayFooterAlert", obj);
            }


          })

      }

      var obj = {

        text: "",
        type: "moving",
        buttons: 2,
        size: "lg",
        lang: this.lang.modal_Moving,
        funcNo: "",
        funcYes: funcYes
      };
      this.$store.dispatch("showModalComponent", obj);



    },
    toggleRightPanel(){
      
      this.$parent.isVisibleRight = !this.$parent.isVisibleRight;
      
    },
    toggleLeftPanel(){
      
      this.$parent.isVisibleLeft = !this.$parent.isVisibleLeft;
      
    }


  },
  
}
</script>


<style scoped>

  .middle{
    border-right: 1px solid #666;
    width: 30%;
  }
</style>



// WEBPACK FOOTER //
// src/components/PartManager/Views/PartTable/Middle/Middle.vue